const i18nConfig = {
  locales: ["en"],
  defaultLocale: "en",
  i18nNamespaces: [
    "home",
    "about",
    "nav",
    "footer",
    "pages",
    "validation",
    "not-found",
    "signin",
    "password-reset",
  ],
  localeDetection: false,
  prefixDefault: false,
};

module.exports = i18nConfig;
